/**
 * SIED status → the compact REG/DEC-style square (T-100). Kept apart from the
 * component so it's testable without the '@/'-aliased UI imports.
 *
 *   SF  funeral_rep_signed              → done    (filled green ✓)
 *   SM  certifier_signed_not_validated  → turn    (blue pen: our turn to sign)
 *   SA  certifier_signed_validated      → turn
 *   NS  not_signed_by_physician         → missing (red ✗)
 *   AN / unknown / no form              → none    (grey dash)
 */
export type SiedCellVariant = 'done' | 'turn' | 'missing' | 'none';

export const SIED_CELL_VARIANT: Record<string, SiedCellVariant> = {
  funeral_rep_signed: 'done',
  certifier_signed_not_validated: 'turn',
  certifier_signed_validated: 'turn',
  not_signed_by_physician: 'missing',
  cancelled: 'none',
  unknown: 'none',
};

export function siedCellVariant(status: string | null | undefined): SiedCellVariant {
  return (status && SIED_CELL_VARIANT[status]) || 'none';
}
